app.service('_', function () {
	// A (possibly faster) way to get the current timestamp as an integer.
	var now = Date.now || function () {
		return new Date().getTime();
	};
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	var debounce = function (func, wait, immediate) {
		var timeout, args, context, timestamp, result;

		var later = function () {
			var last = now() - timestamp;

			if (last < wait && last >= 0) {
				timeout = setTimeout(later, wait - last);
			} else {
				timeout = null;
				if (!immediate) {
					result = func.apply(context, args);
					if (!timeout) context = args = null;
				}
			}
		};

		return function () {
			context = this;
			args = arguments;
			timestamp = now();
			var callNow = immediate && !timeout;
			if (!timeout) timeout = setTimeout(later, wait);
			if (callNow) {
				result = func.apply(context, args);
				context = args = null;
			}

			return result;
		};
	};

	var onScroll = function (fn) {
		var supportsPassive = false;
		var lastKnownScrollPosition = 0;
		var ticking = false;

		try {
			var opts = Object.defineProperty({}, 'passive', {
				get: function () {
					supportsPassive = true;
				}
			});
			window.addEventListener("test", null, opts);
		} catch (e) {
		}

		var handleScroll = function (e) {
			lastKnownScrollPosition = window.pageYOffset;
			if (!ticking) {
				window.requestAnimationFrame(function () {
					fn(lastKnownScrollPosition);
					ticking = false;
				});
			}
			ticking = true;
		};

		window.addEventListener('scroll', handleScroll, supportsPassive ? {passive: true} : false);
	};

	function formatPrice(price) {
		var p = price.toString().split('.');
		var result = p[0];
		if (p[0].length > 3) {
			result = p[0].substr(0, p[0].length - 3) + ' ' + p[0].substr(p[0].length - 3, 3);
		}
		if (p[1]) {
			if (p[1].length == 1) {
				result += ',' + p[1] + '0';
			} else {
				result += ',' + p[1].substr(0, 2);
			}
		}
		return result + ' zł';
	}

	/**
	 * Normalizuje białe znaki w podanym łańcuchu tekstowym.
	 * Usuwa wiodące i końcowe białe znaki, zastępuje sekwencje białych znaków
	 * pojedynczą spacją oraz zamienia niełamliwe spacje (&nbsp;) na zwykłe spacje.
	 *
	 * @param {string|null} str - Źródłowy łańcuch tekstowy do normalizacji, może być null.
	 * @returns {string|null} - Zmodyfikowany łańcuch z unormowanymi białymi znakami, null jeśli wejściowy łańcuch jest null.
	 */
	function normalizeSpace(str) {
		if (str == null || str.trim().length === 0) {
			return str;
		}

		// Replace non-breaking spaces with regular spaces
		let replacedInput = str.replace(/\u00A0/g, ' ');

		let size = replacedInput.length;
		let newChars = [];
		let count = 0;
		let whitespacesCount = 0;
		let startWhitespaces = true;

		for (let i = 0; i < size; i++) {
			let actualChar = replacedInput.charAt(i);
			let isWhitespace = /\s/.test(actualChar);

			if (isWhitespace) {
				if (whitespacesCount === 0 && !startWhitespaces) {
					newChars[count++] = ' ';
				}
				whitespacesCount++;
			} else {
				startWhitespaces = false;
				newChars[count++] = actualChar;
				whitespacesCount = 0;
			}
		}

		if (startWhitespaces) {
			return '';
		}

		return newChars.slice(0, count - (whitespacesCount > 0 ? 1 : 0)).join('').trim();
	}

	return {
		debounce: debounce,
		onScroll: onScroll,
		formatPrice,
		normalizeSpace
	};
});
